<template>
  <!-- 个人继续率统计 OK保用 -->
  <div class="main-container">
    <div class="search-box btn3">
      <div class="input-item">
        <span class="label">继续率月份</span>
        <DatePicker
          transfer
          :options="options"
          format="yyyy-MM"
          type="month"
          :value="searchParams.needPayDate"
          @on-change="searchParams.needPayDate = $event"
          placeholder="请选择"
          :clearable="false"
        >
        </DatePicker>
      </div>
      <div class="input-item">
        <span class="label">机构</span>
        <selectTree
          type="select"
          v-model="searchParams.orgId"
          :params="{
            source: 2
          }"
          ref="selectTreeRef"
        ></selectTree>
      </div>
      <div class="input-item">
        <span class="label">继续率指标</span>
        <Select v-model="searchParams.payNum" :transfer="true">
          <Option value="2">R13</Option>
          <Option value="3">R25</Option>
          <Option value="4">R37</Option>
          <Option value="5">R49</Option>
        </Select>
      </div>
      <div class="input-item two">
        <span class="label">业务员</span>
        <Input v-model="searchParams.staffNo" placeholder="业务员工号" clearable />
        <Input v-model="searchParams.salesmanName" placeholder="业务员姓名" clearable style="margin-left: 15px" />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost @click="daochu()">导出</Button>
        <Button v-if="this.$units.isOkBao()" type="primary" ghost @click="daochuDetail()">导出明细</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <!-- 是否达标 -->
        <template slot-scope="{ row }" slot="isReachStandard">
          <span class="my-tag green" v-if="row.isReachStandard == 1">是</span>
          <span class="my-tag red" v-else>否</span>
        </template>
        <!-- 是否确认 -->
        <template slot-scope="{ row }" slot="isSure">
          <span class="my-tag green" v-if="row.isSure == 1">已确认</span>
          <span class="my-tag red" v-else>未确认</span>
        </template>
        <!-- 结算状态 -->
        <template slot-scope="{ row }" slot="balanceStatus">
          <span class="my-tag red" v-if="row.balanceStatus == -1">不符合结算条件</span>
          <span class="my-tag" v-else-if="row.balanceStatus == 0">未结算</span>
          <span class="my-tag green" v-else-if="row.balanceStatus == 1">已结算</span>
          <span class="my-tag org" v-else>结算中</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span @click="$refs.detailModalRef.open(row)" class="table-btn">详情</span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>

    <!-- 详情 -->
    <detailModal ref="detailModalRef" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import detailModal from './components/detailModal';
import selectTree from '@/components/system/selectTree';
import { pageTool } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config],
  components: {
    selectTree,
    detailModal
  },
  data() {
    return {
      options: {
        disabledDate(date) {
          return dayjs(date).isAfter(dayjs()); // false
        }
      },
      searchParams: {
        needPayDate: dayjs().format('YYYY-MM'),
        payNum: '2'
      }
    };
  },
  mounted() {
    this.initListParams('/buz/renewalRate/okbao/queryRenewalRateList');
  },
  activated() {
    this.getList();
  },
  methods: {
    daochuDetail() {
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/renewalRate/okbao/exportRenewalPolicyList', params, 'POST');
    },
    daochu() {
      if (!this.$units.pointAction('renewalManage_03_export')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/renewalRate/okbao/exportRenewalRateList', params, 'POST');
    },
    setListParams(params) {
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
